import { render, staticRenderFns } from "./DisinfectionTrainingNew.vue?vue&type=template&id=39bdf78e&scoped=true&"
import script from "./DisinfectionTrainingNew.vue?vue&type=script&lang=js&"
export * from "./DisinfectionTrainingNew.vue?vue&type=script&lang=js&"
import style0 from "./DisinfectionTrainingNew.vue?vue&type=style&index=0&id=39bdf78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bdf78e",
  null
  
)

export default component.exports